import React from 'react';

/**
 * Footer Component
 */
const Footer = () => (
	<footer className="footer-main">
		<p className="footer-main__copy">Copyright © {(new Date().getFullYear())} Designed and Developed by Jordan Keen</p>
	</footer>
);

export default Footer;